import React, { useState } from "react";
import { User, Users } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const PurposeSelection = ({ onSelect }) => {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  const options = [
    {
      id: "myself",
      label: "MySelf",
      icon: <User className="w-8 h-8" />,
      description: "I am seeking help for myself.",
    },
    {
      id: "family",
      label: "MyFamily / Caregiver",
      icon: <Users className="w-8 h-8" />,
      description: "I am helping a family member or acting as a caregiver.",
    },
  ];

  const handleSelect = (option) => {
    console.log(option)
    setSelected(option.id);
    if (option.id=="myself") {
      navigate("/doctor_details");
    }
    if (option.id=="family") {
      navigate("/family_login")

    }
  };

  return (
    <div className="bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 min-h-screen flex justify-center items-center relative overflow-hidden p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold text-gray-800">
          What brings you to Aica Health?
        </h1>
        <p className="text-gray-600 mt-2">
          Please choose carefully as you may not be able to edit later.
        </p>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {options.map((option) => (
            <button
              key={option.id}
              onClick={() => handleSelect(option)}
              className={`flex flex-col items-center justify-center rounded-xl border p-6 hover:shadow-lg transition 
                ${selected === option.id ? "border-blue-500 bg-blue-100" : "border-gray-300 bg-white"}`}
            >
              <div className="text-blue-600">{option.icon}</div>
              <h2 className="text-xl font-semibold mt-2">{option.label}</h2>
              <p className="text-gray-500 text-sm mt-1">{option.description}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PurposeSelection;
